import {extendTheme } from '@chakra-ui/react';

const styles = {
  global: {
    'html, body': {
        height:'100%',
    },
    '#root':{
        height:'100%',
    },
    'a:focus': {
        boxShadow: 'none',
        outline: 'none',
    },
  },
};

const theme = extendTheme({ styles });

export default theme;
